<template>
  <header class="pc-header">
    <div class="pc-header-wrapper">
      <a class="pc-logo" :href="getCurLink('//www.gm99.com')" target="_blank">
        <i class="pc-logo-icon"></i>
      </a>
      <div class="account-wrapper">
        <a
          v-if="pageInfo.headerAd && pageInfo.headerAd.href"
          v-show="headerAdState"
          :href="getCurLink(pageInfo.headerAd.href)"
          target="_blank"
          class="ad-btn"
        >
          <img :src="pageInfo.headerAd.img" />
        </a>
        <div class="account-info">
          <div class="logined" v-show="user.id">
            <div class="account-box" v-on:click="toggleAccountBox">
              <a class="account-anchor">
                <img class="avatar" v-bind:src="avatar" />
              </a>
              <span class="user-name showOps">{{ user.name }}</span>
              <span class="select-icon-wrapper">
                <i class="select-icon"></i>
              </span>
            </div>

            <nav class="account-opera" v-show="accountBoxState">
              <a
                class="account-center opBtn"
                :href="getCurLink('//www.gm99.com/center')"
                target="blank"
              >
                <i class="account-center-icon icon"></i>
                <span class="t">會員中心</span>
              </a>
              <a
                class="account-message opBtn"
                :href="getCurLink('//www.gm99.com/center?type=message')"
                target="blank"
              >
                <i class="account-message-icon icon"></i>
                <span class="t">
                  消息
                  <span class="remain-msg">({{ unreadMsg }})</span>
                </span>
              </a>
              {{ login_type }}
              <a
                class="account-switch opBtn"
                v-on:click="showAccount(login_type.switchAccount)"
              >
                <i class="account-switch-icon icon"></i>
                <span class="t">切換帳號</span>
              </a>
            </nav>
          </div>
          <div class="beforeLogin" v-show="!user.id">
            <button
              href
              class="beforeLogin-registered account-btn"
              @click="showAccount(login_type.registerAccount)"
            >
              <i class="icon"></i>註冊
            </button>
            <button
              href
              class="beforeLogin-login account-btn"
              @click="showAccount(login_type.loginAccount)"
            >
              <i class="icon"></i>登入
            </button>
          </div>
        </div>
        <div class="collect-wrapper">
          <a
            class="collect-btn j-favour-btn j-header-favour-btn"
            href="javascript:;"
            @click="favourFn"
          >
            <i class="like-icon"></i>
            <span class="colect-text">收藏</span>
          </a>
          <a
            class="collect-btn j-download-btn j-header-download-btn"
            href="javascript:;"
            @click="downloadFn"
            v-if="pageInfo.headerDownload"
          >
            <i class="download-icon"></i>
            <span class="colect-text">下載</span>
          </a>
          <a
            class="collect-btn j-gift-list"
            href="javascript:;"
            v-if="pageInfo.headerGift"
            @click="openGiftList"
          >
            <i class="gift-icon"></i>
            <span class="colect-text">禮包</span>
          </a>
          <a
            class="collect-btn code-btn"
            href="javascript:;"
            v-if="pageInfo.headerQrcode"
          >
            <i class="code-icon"></i>
            <span class="colect-text">&nbsp;</span>
            <div class="code">
              <img class="codebg" :src="pageInfo.qrCode.bg" />
              <p :style="fontColor">
                用手機掃一下也能
                <br />在手機上玩唷~
              </p>
              <img class="codeimg" :src="pageInfo.qrCode.img" />
            </div>
          </a>
          <a
            class="collect-btn j-website-btn"
            :href="getCurLink(gameSite)"
            target="_blank"
            v-if="pageInfo.headerWebsite"
          >
            <i class="website-icon"></i>
            <span class="colect-text">官網</span>
          </a>
          <a
            class="collect-btn"
            v-if="pageInfo.apkDownload"
            :href="apkUrl"
            target="_blank"
          >
            <i class="apk-icon"></i>
            <span class="colect-text">apk下載</span>
          </a>
          <a
            class="collect-btn"
            v-if="pageInfo.headerScreen"
            href="javascript:;"
            @click="toggleFullScreen"
          >
            <i class="fullscreen-icon"></i>
            <span class="colect-text">全螢幕</span>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { UNREAD_MSG } from '../store/pc'
import Download from '../mixins/Download'
import Favour from '../mixins/Favour'
import { ACCOUNT_TYPE } from './Account'
export default {
  data() {
    return {
      accountBoxState: false,
      login_type: ACCOUNT_TYPE,
      gameSite: window.gameSite
    }
  },
  mixins: [Download, Favour],
  mounted() {
    this.$store.dispatch(UNREAD_MSG)
    if (window.pageInfo.apkDownload) {
      this.$store.dispatch('getWebsiteInfo')
    }
  },
  computed: {
    fontColor() {
      return `color:${this.pageInfo.color.font}`
    },
    avatar() {
      return this.user.id && this.user.avatar
        ? this.user.avatar + '?v=' + new Date().getTime()
        : ''
    },
    headerAdState() {
      if (!this.pageInfo.headerAd.href) {
        return false
      }
      let startTime = new Date(this.pageInfo.headerAd.startTime).getTime()
      let endTime = new Date(this.pageInfo.headerAd.endTime).getTime()
      let now = new Date().getTime()
      return now > startTime && now < endTime
    },
    ...mapGetters(['user', 'unreadMsg', 'pageInfo']),
    ...mapState(['apkUrl'])
  },
  methods: {
    getCurLink(link) {
      return window.globalGetGotoLink({ link })
    },
    toggleAccountBox() {
      this.accountBoxState = !this.accountBoxState
    },
    showAccount(type) {
      this.accountBoxState = false
      this.$emit('showAccount', type)
    },
    openGiftList() {
      this.$store.commit('updateState', {
        action: 'giftListPopupState',
        value: true
      })
    },
    toggleFullScreen() {
      this.$store.commit('toggleFullScreenState')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PcHeader.vue